/**
 * Poster-first video cards.
 *
 * Shared by the "happy paddlers" strip and the editorial split — both show a
 * poster with a centred play circle and only reveal native controls once
 * playback starts. Native controls at rest replace the circle with a bar along
 * the bottom edge and lose the poster framing.
 *
 * Contract: an element with [data-video-card] containing a <video> and a
 * [data-video-play] button. Adds .is-playing to the card while it plays.
 */
(function () {
  'use strict';

  const cards = document.querySelectorAll('[data-video-card]');
  if (!cards.length) return;

  const videos = [];

  cards.forEach((card) => {
    const video = card.querySelector('video');
    const button = card.querySelector('[data-video-play]');
    if (!video || !button) return;
    videos.push(video);

    button.addEventListener('click', () => {
      // These clips carry sound. Two playing at once is unusable, and the
      // visitor has no obvious way to tell which card to go and stop.
      videos.forEach((other) => {
        if (other !== video) other.pause();
      });

      video.controls = true;
      card.classList.add('is-playing');
      const started = video.play();
      // Older Safari returns undefined rather than a promise.
      if (started && typeof started.catch === 'function') {
        started.catch(() => {
          // Autoplay policy or a missing source: put the poster back rather
          // than leaving a dead black rectangle with no way to retry.
          video.controls = false;
          card.classList.remove('is-playing');
        });
      }
    });

    // Returning to the start shows the poster again, so restore the circle with
    // it — otherwise the card looks playable but has no visible control.
    video.addEventListener('ended', () => {
      video.controls = false;
      card.classList.remove('is-playing');
    });
  });
})();
